@if (m_showCompletedState) {
    <form class="stepper-wrapper">
        <div fxLayout="column" fxLayoutAlign="center center">
            <br/>
            <br/>
            <h1 style="font-size: 2em">[ 🎉 {{ 'account.congratulations' | transloco }} 🎊 ]</h1>
            <br/>
            <br/>
            <mat-label class="upgradeFontLrg" style="text-align: center">
                {{ 'account.reLogin' | transloco }}
            </mat-label>
            <br/>
            @if (resellerUser && resellerUser.length > 3) {
                <div style="font-size: 1.2em">
                    <mat-label style="text-align: center">
                        {{ 'account.newEnterpriseName' | transloco }}
                    </mat-label>
                    <br/>
                    <mat-label style="text-align: center">
                        {{ 'account.useCredentials' | transloco }}
                    </mat-label>
                    <br/>
                    <mat-label style="text-align: center">
                        {{ 'account.continueWithUser' | transloco }}
                    </mat-label>
                    <br/>
                    <br/>
                    <div fxFlex fxLayout="column" fxLayoutAlign="center center">
                        <div style="text-align: center">
                            <mat-label style="text-align: center; color: red">
                                {{ 'account.saveCredentials' | transloco }}
                            </mat-label>
                            <br/>
                            <br/>
                            <mat-divider></mat-divider>
                            <br/>
                            <br/>
                            <span class="upgradeFontLrg newCredentials">{{ 'account.' | transloco }}new user: {{ resellerUser }}</span>
                            <span style="padding-left: 20px" class="upgradeFontLrg newCredentials"> | </span>
                            <span style="padding-left: 20px" class="upgradeFontLrg newCredentials">{{ 'account.' | transloco }}new password: {{ resellerPass }}</span>
                            <br/>
                            <br/>
                            <mat-divider></mat-divider>
                            <br/>
                            <br/>
                            <div fxFlex fxLayout="column" fxLayoutAlign="center center">
                                <button class="finalButtons" color="warn" (click)="copyUserPass()" mat-raised-button>
                                    <mat-icon>content_copy</mat-icon>
                                    {{ 'account.copyCredentials' | transloco }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            } @else {
                <div style="text-align: center; font-weight: bolder; font-size: 3em">
                    <span style="text-align: center; font-weight: bolder; font-size: 3em">{{ m_timer }}</span>
                </div>
            }
            <ng-template #timer>
                <div style="text-align: center; font-weight: bolder; font-size: 3em">
                    <span style="text-align: center; font-weight: bolder; font-size: 3em">{{ m_timer }}</span>
                </div>
            </ng-template>
            <br/>
            <br/>
            <button class="finalButtons" color="accent" (click)="reloadStudio()" mat-raised-button>
                <mat-icon>cached</mat-icon>
                {{ 'account.reloadStudio' | transloco }}
            </button>
        </div>
    </form>
}
@if (!m_showCompletedState) {
    <form class="stepper-wrapper" [formGroup]="form" (ngSubmit)="submit($event)" novalidate autocomplete="off">
        <div class="greatFeatures">
            <div fxFlex="column" class="noBorder">
                <!--            <div class="svgSpecialOfferContainer">-->
                <!--                <app-svg-icon class="noBorder" path="/assets/sale1.svg"></app-svg-icon>-->
                <!--            </div>-->
                @if (showCloseButton) {
                    <button (click)="close()" class="priceCut" mat-icon-button color="warn">
                        <mat-icon>cancel</mat-icon>
                    </button>
                }
                <!--            <img *ngIf="!m_viewOnly" class="priceCut" src="./assets/images/pricecut.png"/>-->
                @if (!m_viewOnly) {
                    <div style="width: 100%; text-align: center">
                        <span class="specialPriceText">{{ 'account.upgCloud' | transloco }}</span>
                    </div>
                }
                @if (m_viewOnly) {
                    <div style="text-align: left">
                        <span>{{ 'account.signagePlans' | transloco }}</span>
                    </div>
                }
            </div>
        </div>
        <div class="step-header">
            @if (selectedStep == 0) {
                <span>{{ 'general.screens' | transloco }}</span>
            }
            @if (selectedStep == 1) {
                <span>{{ 'placeholder.info' | transloco }}</span>
            }
            @if (selectedStep == 2) {
                <span>{{ 'placeholder.payment' | transloco }}</span>
            }
            @if (selectedStep == 3) {
                <span>{{ 'general.action' | transloco }}</span>
            }
        </div>
        @if (!m_viewOnly) {
            <div class="stepper-btn">
                @if (selectedStep != 0) {
                    <button mat-raised-button color="warn" (click)="stepper.previous()" [disabled]="!enabledBack()">{{ 'general.back' | transloco }}</button>
                }
                @if (selectedStep != 3) {
                    <button mat-raised-button color="warn" (click)="stepper.next()" [disabled]="!enabledNext()">{{ 'general.next' | transloco }}</button>
                }
            </div>
        }
        <mat-horizontal-stepper linear #stepper (selectionChange)="onStepChange($event)">
            <mat-step>
                <ng-template matStepLabel>{{ 'general.screens' | transloco }}</ng-template>
                <div class="why-upgrade step-body-wrapper">
                    <div fxLayout="column" fxLayoutAlign="center center">
                        <!--                    <video id="singleVideo" style="width: 100%" [vgMedia]="$any(media)" #media [autoplay]="true" crossorigin>-->
                        <!--                        <source src="assets/logos/build.mp4" type="video/mp4">-->
                        <!--                    </video>-->
                        <mat-button-toggle-group appearance="legacy" class="panel-button-group" formControlName="package" (change)="onPackageSelected($event)">
                            @for (item of m_subscriptionPackages; track item) {
                                <mat-button-toggle disableRipple class="panel-radio-button toggleIcons1" [value]="item">
                                    <div>
                                        @switch (item) {
                                            @case ('free') {
                                                <div class="package">
                                                    <mat-icon [color]="selectedColorFree">auto_awesome</mat-icon>
                                                    <span>{{ 'general.' + item | transloco }}</span>
                                                    <!--  <span>{{ 'general.' + item | transloco }} </span> -->
                                                </div>
                                            }
                                            @case ('plus') {
                                                <div class="package">
                                                    <mat-icon [color]="selectedColorPlus">star_border</mat-icon>
                                                    <span>{{ 'general.' + item | transloco }}</span>
                                                    <!--  <span>{{ 'general.' + item | transloco }} </span> -->
                                                </div>
                                            }
                                            @case ('enterprise') {
                                                <div class="package">
                                                    <mat-icon [color]="selectedColorEnterprise">star_rate</mat-icon>
                                                    <span>{{ 'general.' + item | transloco }}</span>
                                                    <!--  <span>{{ 'general.' + item | transloco }} </span> -->
                                                </div>
                                            }
                                        }
                                    </div>
                                </mat-button-toggle>
                            }
                        </mat-button-toggle-group>
                        @if (selectedPackage === 'free') {
                            <div>
                                <div>
                                    <br/>
                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                        <span class="pricesEstimatesTop">{{ 'general.estScreens2' | transloco }}</span>
                                        <mat-form-field class="form-element priceForm">
                                            <mat-label>{{ 'general.license' | transloco }}</mat-label>
                                            <input #priceInputPlus class="priceInput"
                                                   (keyup)="onCalcPrice()"
                                                   (change)="onCalcPrice()"
                                                   min="1" max="{{MAX_SCREENS}}" matInput
                                                   type="number"
                                                   autocomplete="nope"
                                                   placeholder=""
                                                   formControlName="pricesScreen"/>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%">
                    <span>
                      <mat-icon class="chevy">chevron_right</mat-icon>
                      <mat-label class="pricesEstimates smallScreen">{{ 'general.costScreen' | transloco }}:</mat-label>
                    </span>
                                            <span class="pps">$0.00</span>
                                        </div>
                                        <br/>
                                        <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%">
                    <span>
                      <mat-icon class="chevy">chevron_right</mat-icon>
                      <mat-label class="pricesEstimates smallScreen">{{ 'general.costMonth' | transloco }}:</mat-label>
                    </span>
                                            <span class="pps pps2">$0.00</span>
                                        </div>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <br/>
                                        @if (selectedPackage == 'free') {
                                            <div>
                                                <li class="sideNotes smallScreen">
                                                    {{ 'account.freePlan' | transloco }}
                                                </li>
                                            </div>
                                        }
                                        @if (selectedPackage != 'free') {
                                            <div>
                                                <li class="sideNotes">
                                                    {{ 'general.upgGrow2' | transloco }}
                                                </li>
                                                @if ($any(priceInputPlus.value) >= MAX_SCREENS) {
                                                    <li class="sideNotes smallScreen">
                                                        {{ 'general.upgContactLive' | transloco }}
                                                    </li>
                                                }
                                                @if ($any(priceInputPlus.value) == 1) {
                                                    <li class="sideNotes smallScreen">
                                                        {{ 'general.upgEasy2' | transloco }}
                                                    </li>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                                <br/>
                            </div>
                        }
                        @if (selectedPackage === 'plus') {
                            <div>
                                <div>
                                    <br/>
                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                        <span class="pricesEstimatesTop">{{ 'general.estScreens2' | transloco }}</span>
                                        <mat-form-field class="form-element priceForm">
                                            <mat-label>{{ 'general.license' | transloco }}</mat-label>
                                            <input #priceInputPlus class="priceInput"
                                                   (keyup)="onCalcPrice()"
                                                   (change)="onCalcPrice()"
                                                   min="1" max="{{MAX_SCREENS}}" matInput
                                                   type="number"
                                                   autocomplete="nope"
                                                   placeholder=""
                                                   formControlName="pricesScreen"/>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <!-- plus price  -->
                                        <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%">
                      <span>
                        <mat-icon class="chevy">chevron_right</mat-icon>
                        <mat-label class="pricesEstimates smallScreen">{{ 'general.costScreen' | transloco }}:</mat-label>
                      </span>
                                            <span class="pps">{{ $any(PLUS_FLAT_PRICE) | StringJSV2Pipe:stringJSPipeArgs }}</span>
                                        </div>
                                        <br/>
                                        <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%">
                      <span>
                        <mat-icon class="chevy">chevron_right</mat-icon>
                        <mat-label class="pricesEstimates smallScreen">{{ 'general.costMonth' | transloco }}:</mat-label>
                      </span>
                                            <span class="pps pps2">{{ licencesPlus | StringJSV2Pipe:stringJSPipeArgs }} </span>
                                        </div>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <li class="sideNotes">
                                            {{ 'general.upgGrow2' | transloco }}
                                        </li>
                                        <br/>
                                        @if ($any(priceInputPlus.value) >= MAX_SCREENS) {
                                            <li class="sideNotes smallScreen">
                                                {{ 'general.upgContactLive' | transloco }}
                                            </li>
                                        }
                                        @if ($any(priceInputPlus.value) == 1) {
                                            <li class="sideNotes smallScreen">
                                                {{ 'general.upgEasy2' | transloco }}
                                            </li>
                                        }
                                    </div>
                                </div>
                                <br/>
                            </div>
                        }
                        @if (selectedPackage === 'enterprise') {
                            <div>
                                <div>
                                    <br/>
                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                        <span class="pricesEstimatesTop">{{ 'general.estScreens2' | transloco }}</span>
                                        <mat-form-field class="form-element priceForm">
                                            <mat-label>{{ 'general.license' | transloco }}</mat-label>
                                            <input class="priceInput" #priceInputEnterprise
                                                   min="1" max="{{MAX_SCREENS}}"
                                                   (keyup)="onCalcPrice()"
                                                   (change)="onCalcPrice()"
                                                   matInput type="number"
                                                   autocomplete="off"
                                                   formControlName="pricesScreen"/>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div>
                                    <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%">
                      <span>
                        <mat-icon class="chevy">chevron_right</mat-icon>
                        <mat-label class="pricesEstimates smallScreen">{{ 'general.costScreen' | transloco }}:</mat-label>
                      </span>
                                        <span class="pps"> {{ licence | StringJSV2Pipe:stringJSPipeArgs }}</span>
                                    </div>
                                    <br/>
                                    <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%">
                      <span>
                        <mat-icon class="chevy">chevron_right</mat-icon>
                        <mat-label class="pricesEstimates smallScreen">{{ 'general.costMonth' | transloco }}:</mat-label>
                      </span>
                                        <span class="pps pps2">{{ licencesEnterprise | StringJSV2Pipe:stringJSPipeArgs }} </span>
                                    </div>
                                    <br/>
                                    <br/>
                                    <br/>
                                    <li class="sideNotes">
                                        {{ 'general.upgGrow2' | transloco }}
                                    </li>
                                    <br/>
                                    @if ($any(priceInputEnterprise.value) >= MAX_SCREENS) {
                                        <li class="sideNotes smallScreen">
                                            {{ 'general.upgContactLive' | transloco }}
                                        </li>
                                    }
                                    @if ($any(priceInputEnterprise.value) == 1) {
                                        <li class="sideNotes smallScreen">
                                            {{ 'general.upgEasy2' | transloco }}
                                        </li>
                                    }
                                </div>
                                <br/>
                            </div>
                        }
                        <!-- video -->
                        <!--                <video id="singleVideo" style="width: 100%" [vgMedia]="$any(media)" #media [autoplay]="true" crossorigin>-->
                        <!--                    <source src="assets/logos/build.mp4" type="video/mp4">-->
                        <!--                </video>-->
                        <!-- old prices  -->
                        <!--                    <mat-form-field style="width: 90%;">-->
                        <!--                        <mat-label>{{ 'general.howManyScreensWillYouManage' | transloco }}</mat-label>-->
                        <!--                        <mat-select #matSelect [(value)]="pricingSelected">-->
                        <!--                            <mat-option *ngFor="let pricePackage of pricePackages" [value]="pricePackage">-->
                        <!--                                <span>{{ pricePackage.text }}</span>-->
                        <!--                            </mat-option>-->
                        <!--                        </mat-select>-->
                        <!--                    </mat-form-field>-->
                        <!--                    <div *ngIf="matSelect?.value?.price" class="priceDiv" fxLayout="column">-->
                        <!--                        <mat-label class="font16 fontColor">-->
                        <!--                            {{ 'general.pricePerMonth' | transloco }}:-->
                        <!--                            <span class="fontColor" style="font-size: 1em">-->
                        <!--                                {{ matSelect?.value?.price }}-->
                        <!--                            </span>-->
                        <!--                        </mat-label>-->
                        <!--                        <br/>-->
                        <!--                        <mat-label class="fontColor">-->
                        <!--                            {{ 'general.autoPrice2' | transloco }}-->
                        <!--                        </mat-label>-->
                        <!--                    </div>-->
                    </div>
                    @if (selectedPackage === 'free') {
                        <div fxLayout="column">
                            <!--                    <span fxLayout="row" class="wiggle">-->
                            <!--                        <mat-label class="fontColor" style="font-size: 1.2em; padding: 5px">{{ 'general.enterpriseAdvantage' | transloco }}</mat-label>-->
                            <!--                    </span>-->
                            <!--                    <div fxLayout="row" style="padding-top: 5px">-->
                            <!--                        <fa-icon size='lg' [icon]="faHtml5"></fa-icon>-->
                            <!--                        <fa-icon size='lg' [icon]="faQrcode"></fa-icon>-->
                            <!--                        <fa-icon size='lg' [icon]="faShield"></fa-icon>-->
                            <!--                        <fa-icon size='lg' [icon]="faMobileScreen"></fa-icon>-->
                            <!--                        <fa-icon size='lg' [icon]="faCode"></fa-icon>-->
                            <!--                    </div>-->
                            <!--                    <div fxLayout="row" style="padding-top: 5px">-->
                            <!--                        <fa-icon size='lg' [icon]="faCode"></fa-icon>-->
                            <!--                        <fa-icon size='lg' [icon]="faMobileScreen"></fa-icon>-->
                            <!--                        <fa-icon size='lg' [icon]="faCode"></fa-icon>-->
                            <!--                    </div>-->
                            <br/>
                            <mat-divider></mat-divider>
                            <br/>
                            <div class="fontColor">
                                <li>100% FREE</li>
                                <li>manage up to 3 screen</li>
                                <li>1GB of cloud storage</li>
                                <li>Persistent WatchDog</li>
                            </div>
                            <br/>
                            <mat-divider></mat-divider>
                        </div>
                    }
                    @if (selectedPackage === 'plus') {
                        <div fxLayout="column">
                            <!--                    <span fxLayout="row" class="wiggle">-->
                            <!--                        <mat-label class="fontColor" style="font-size: 1.2em; padding: 5px">{{ 'general.enterpriseAdvantage' | transloco }}</mat-label>-->
                            <!--                    </span>-->
                            <div fxLayout="row" style="padding-top: 5px">
                                <fa-icon size='lg' [icon]="faHtml5"></fa-icon>
                                <fa-icon size='lg' [icon]="faQrcode"></fa-icon>
                                <fa-icon size='lg' [icon]="faShield"></fa-icon>
                                <fa-icon size='lg' [icon]="faMobileScreen"></fa-icon>
                                <fa-icon size='lg' [icon]="faCode"></fa-icon>
                            </div>
                            <!--                    <div fxLayout="row" style="padding-top: 5px">-->
                            <!--                        <fa-icon size='lg' [icon]="faCode"></fa-icon>-->
                            <!--                        <fa-icon size='lg' [icon]="faMobileScreen"></fa-icon>-->
                            <!--                        <fa-icon size='lg' [icon]="faCode"></fa-icon>-->
                            <!--                    </div>-->
                            <br/>
                            <mat-divider></mat-divider>
                            <br/>
                            <div class="fontColor">
                                <li>all scene templates</li>
                                <li>all animation templates</li>
                                <li>3GB of cloud storage</li>
                                <li>unlimited cloud traffic</li>
                                <li>external content components</li>
                                <li>countdown components</li>
                                <li>advanced Scheduler</li>
                                <li>QR and Kiosk integration</li>
                                <li>persistent WatchDog</li>
                            </div>
                            <br/>
                            <mat-divider></mat-divider>
                        </div>
                    }
                    @if (selectedPackage === 'enterprise') {
                        <div fxLayout="column">
                            <!--                    <span fxLayout="row" class="wiggle">-->
                            <!--                        <mat-label class="fontColor" style="font-size: 1.2em; padding: 5px">{{ 'general.enterpriseAdvantage' | transloco }}</mat-label>-->
                            <!--                    </span>-->
                            <div fxLayout="row" style="padding-top: 5px">
                                <fa-icon size='lg' [icon]="faYouTube"></fa-icon>
                                <fa-icon size='lg' [icon]="faHtml5"></fa-icon>
                                <fa-icon size='lg' [icon]="faQrcode"></fa-icon>
                                <fa-icon size='lg' [icon]="faTwitter"></fa-icon>
                                <fa-icon size='lg' [icon]="faFacebook"></fa-icon>
                                <fa-icon size='lg' [icon]="faShield"></fa-icon>
                                <fa-icon size='lg' [icon]="faDropbox"></fa-icon>
                                <fa-icon size='lg' [icon]="faTiktok"></fa-icon>
                                <fa-icon size='lg' [icon]="faReddit"></fa-icon>
                                <fa-icon size='lg' [icon]="faLinkedin"></fa-icon>
                            </div>
                            <div fxLayout="row" style="padding-top: 5px">
                                <fa-icon size='lg' [icon]="faGoogleDrive"></fa-icon>
                                <fa-icon size='lg' [icon]="faCalendar"></fa-icon>
                                <fa-icon size='lg' [icon]="faCode"></fa-icon>
                                <fa-icon size='lg' [icon]="faVimeo"></fa-icon>
                                <fa-icon size='lg' [icon]="faMobileScreen"></fa-icon>
                                <fa-icon size='lg' [icon]="faTiktok"></fa-icon>
                                <fa-icon size='lg' [icon]="faCode"></fa-icon>
                                <fa-icon size='lg' [icon]="faInstagram"></fa-icon>
                                <fa-icon size='lg' [icon]="faTelegram"></fa-icon>
                                <fa-icon size='lg' [icon]="faGooglePlus"></fa-icon>
                            </div>
                            <br/>
                            <mat-divider></mat-divider>
                            <br/>
                            <div class="fontColor">
                                <li>unlimited templates</li>
                                <li>unlimited cloud storage</li>
                                <li>unlimited cloud traffic</li>
                                <li>YouTube streaming</li>
                                <li>Web content component</li>
                                <li>Advanced Scheduler</li>
                                <li>QR and Kiosk integration</li>
                                <li>Remote Control with touch</li>
                                <li>Persistent WatchDog</li>
                                <li>Social components</li>
                                <li>Post to social networks</li>
                                <li>multi user management</li>
                                <li>branding / reselling</li>
                                <li>advertising manager</li>
                                <li>access control list</li>
                                <li>proof of play reports</li>
                                <li>user privileges</li>
                                <li>admin enterprise dashboards</li>
                                <li>open source software access</li>
                                <li>product discounts</li>
                                <li>phone support</li>
                                <li>and more...</li>
                            </div>
                            <br/>
                            <mat-divider></mat-divider>
                        </div>
                    }
                </div>
            </mat-step>
            @if (!m_viewOnly) {
                <mat-step>
                    <ng-template matStepLabel>{{ 'placeholder.information' | transloco }}</ng-template>
                    <div class="step-body-wrapper">
                        <app-fintech-contact></app-fintech-contact>
                    </div>
                </mat-step>
            }
            @if (!m_viewOnly) {
                <mat-step>
                    <ng-template matStepLabel>{{ 'placeholder.payment' | transloco }}</ng-template>
                    <div class="step-body-wrapper">
                        <app-fintech-paymethod-editor setFintechMode="WIZARD"></app-fintech-paymethod-editor>
                    </div>
                </mat-step>
            }
            @if (!m_viewOnly) {
                <mat-step>
                    <ng-template matStepLabel>{{ 'general.action' | transloco }}</ng-template>
                    <div class="step-body-wrapper" fxFlex fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="32px">
                        <a style="color: deepskyblue; cursor: pointer" href="https://digitalsignage.com/_html/agreement_eula.html" target="_blank"> {{ 'placeholder.eula' | transloco }}</a>
                        <a style="color: deepskyblue; cursor: pointer; position: relative; top: -20px" href="https://digitalsignage.com/_html/agreement_reseller.html" target="_blank"> {{ 'placeholder.entEula' | transloco }}</a>
                        <mat-checkbox #agreed (change)="form.get('status').setValue($event.checked? 'I Agree':'')">
                            I agree | continue
                        </mat-checkbox>
                        <br/>
                        @if (selectedPackage !== 'free') {
                            <mat-label style="text-align: center">subscribing to the <span style="color: #09cb56; font-weight: bold"> [ {{ selectedPackage.toUpperCase() }} ] </span> package</mat-label>
                        }
                        @if (selectedPackage === 'free') {
                            <mat-label style="font-weight: bolder; text-align: center">no need to upgrade, since it's 100% FREE</mat-label>
                        }
                        @if (wizardMode === 'NEW_SUBSCRIBER') {
                            <button
                                    (click)="onSubmitForm($event, 'NEW_SUBSCRIBER')" class="subButton" color="warn" mat-raised-button type="submit"
                                    [disabled]="form.invalid || waitingUpgrade || selectedPackage === 'free'">
                                @if (!waitingUpgrade) {
                                    <span>
                                        <mat-icon>auto_awesome</mat-icon>
                                        <span class="fixButtonUpg">{{ 'general.upgrade' | transloco }}</span>
                                    </span>
                                }
                                @if (waitingUpgrade) {
                                    <div>
                                        <app-loading [size]="'20px'" [style]="{'position': 'relative', 'left': '-120px', 'top': '1px'}"></app-loading>
                                    </div>
                                }
                            </button>
                        }
                        @if (form.invalid && agreed.checked) {
                            <mat-label class="warnBox">
                                {{ 'account.correctFields' | transloco }}
                            </mat-label>
                        }
                        @if (wizardMode === 'UPDATE') {
                            <button
                                    (click)="onSubmitForm($event, 'UPDATE')" class="subButton" color="warn" mat-raised-button type="submit"
                                    [disabled]="form.invalid || disableUpdateButton">
                                @if (!waitingUpgrade) {
                                    <span>
                <mat-icon>save</mat-icon>
                <span class="fixButtonUpg">{{ 'general.update' | transloco }}</span>
              </span>
                                }
                                @if (waitingUpgrade) {
                                    <div>
                                        <app-loading [size]="'20px'" [style]="{'position': 'relative', 'left': '-120px', 'top': '-1px'}"></app-loading>
                                    </div>
                                }
                            </button>
                        }
                    </div>
                </mat-step>
            }
        </mat-horizontal-stepper>
    </form>
}

